// extracted by mini-css-extract-plugin
export default {"logo":"createPayway_logo__bT3JF","body":"createPayway_body__ESR1l","body__title":"createPayway_body__title__X6G6S","body__button":"createPayway_body__button__RhxEw"};